import { render, staticRenderFns } from "./CenteredModuleBox.vue?vue&type=template&id=02aa82b9&scoped=true&"
import script from "./CenteredModuleBox.vue?vue&type=script&lang=js&"
export * from "./CenteredModuleBox.vue?vue&type=script&lang=js&"
import style0 from "./CenteredModuleBox.vue?vue&type=style&index=0&id=02aa82b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aa82b9",
  null
  
)

export default component.exports